export const CONSOLIDATED_FEED_GROUP_ID = "consolidated-feed";
export const CONSOLIDATED_FEED_ORDER_TITLE = "Consolidated feed order";

export const CART_PROGRESS_COLOR_READY = "#22c55e";
export const CART_PROGRESS_COLOR_WARNING = "#facc15";
export const CART_PROGRESS_COLOR_LOW = "#ef4444";

export const CART_IMPORT_TEXT = {
    NOT_FOUND_GTINS: "Not Found Products GTIN:",
    MOQ_NOT_MET:
        "Products with the following GTIN did not meet the minimum order quantity:",
} as const;
